import { BidiModule } from "@angular/cdk/bidi";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UiAssigneeModule } from "../assignee/assignee.module";
import { UiButtonModule } from "../button/button.module";
import { UiIconModule } from "../icon/icon.module";
import { UiChipComponent } from "./chip.component";

@NgModule({
  imports: [CommonModule, BidiModule, UiIconModule, UiButtonModule, UiAssigneeModule],
  declarations: [UiChipComponent],
  exports: [UiChipComponent],
})
export class UiChipModule {}
